import { useQuery } from '@tanstack/react-query';
import tenantService, { TenantBranding, Tenant } from '../services/tenantService';

/**
 * Hook to fetch and cache current tenant branding
 * Uses React Query for automatic caching and deduplication
 */
export function useTenantBranding() {
  return useQuery<TenantBranding, Error>({
    queryKey: ['tenantBranding', 'current'],
    queryFn: tenantService.getCurrentTenantBranding,
    staleTime: 10 * 60 * 1000, // Branding rarely changes - fresh for 10 minutes
    gcTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
    retry: 2,
  });
}

/**
 * Hook to fetch and cache current tenant info
 * Uses React Query for automatic caching and deduplication
 */
export function useTenantInfo() {
  return useQuery<Tenant, Error>({
    queryKey: ['tenant', 'current'],
    queryFn: tenantService.getCurrentTenant,
    staleTime: 10 * 60 * 1000, // Tenant info rarely changes - fresh for 10 minutes
    gcTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
    retry: 2,
  });
}
